import { UNIT_CO2, UNIT_CO2_KG, UNIT_CO2_TEU, UNIT_KG, UNIT_TONNE } from '@/lib/constants';
import { EmissionStats } from '@/types';
import { FuelBurnUnitType } from '@/types/api-types';

const suffix: { [unit: string]: string } = {
  [UNIT_CO2_TEU]: ` (per TEU)`,
  [UNIT_CO2_KG]: ` (per 100${UNIT_KG})`,
  unknown: '',
};

export const formatEmissionsNum = (value: number, includeUnit = true): string => {
  const formatter = new Intl.NumberFormat('en-EN');
  const isTonnes = value > 999;
  const isGrams = value < 1;
  const unitValue = isTonnes ? (value / 1000).toFixed(2) : value.toFixed(isGrams ? 1 : 0);
  const unitType = formatEmissionsUnit(value);
  return `${formatter.format(Number(unitValue))}${includeUnit ? unitType : ''}`;
};

export const formatEmissionsString = (
  num?: number,
  unit?: FuelBurnUnitType,
  includeSuffix = false,
  includeUnit = true,
) => {
  if (!num || !unit) return 'n/a';
  return `${formatEmissionsNum(num, includeUnit)} ${includeUnit ? UNIT_CO2 : ''}${includeSuffix ? formatEmissionsSuffix(unit) : ''}`;
};

export const formatEmissionsRangeString = (
  { min, max, unit }: EmissionStats,
  includeSuffix = false,
  includeUnit = true,
) => {
  if (!min || !unit) return 'n/a';

  if (min !== max) {
    // If they are different return range value
    return `${formatEmissionsNum(min, includeUnit)}-${formatEmissionsString(max, unit, includeSuffix, includeUnit)}`;
  }
  // Return single value
  return formatEmissionsString(min, unit, includeSuffix, includeUnit);
};

export const formatEmissionsUnit = (value: number): string => {
  const isTonnes = value > 999;
  const unitType = isTonnes ? UNIT_TONNE : UNIT_KG;
  return unitType;
};

export const formatEmissionsSuffix = (unit: FuelBurnUnitType) => {
  return suffix[unit];
};
